// Source: https://stackoverflow.com/a/59185109
import isSSR from '@calm/web-common/dist/isSSR';
import { useState, useEffect, useCallback } from 'react';

export type WindowDimensions = {
    width?: number;
    height?: number;
    /** inner width without scrollbar */
    clientWidth?: number;
    /** inner height without scrollbar */
    clientHeight?: number;
};

function getWindowDimensions(): WindowDimensions {
    const hasWindow = !isSSR();
    const width = hasWindow ? window.innerWidth : undefined;
    const height = hasWindow ? window.innerHeight : undefined;
    const clientWidth = hasWindow
        ? window.document.body.clientWidth
        : undefined;
    const clientHeight = hasWindow
        ? window.document.body.clientHeight
        : undefined;
    return {
        width,
        height,
        clientWidth,
        clientHeight,
    };
}

export function useWindowDimensions(
    onResize?: (windowDimensions: WindowDimensions) => void
) {
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );

    const setDimensions = useCallback(() => {
        const dimensions = getWindowDimensions();
        setWindowDimensions(dimensions);
        onResize?.(dimensions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSSR()) {
            window.addEventListener('load', setDimensions);
            window.addEventListener('resize', setDimensions);
            return () => {
                window.removeEventListener('load', setDimensions);
                window.removeEventListener('resize', setDimensions);
            };
        }
    }, [setDimensions]);

    return windowDimensions;
}
